import { graphql } from "gatsby"
import React from "react"
import ReactMarkdown from "react-markdown"
import remarkGfm from "remark-gfm"
import ChangeHeaderInView from "../components/changeHeaderinView"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { COLOR_STATES } from "../context/menuContext"
import { useLanguage } from "../hooks/useLanguage"

export default function TermsAndConditions({ data }) {
    const { switchLanguage } = useLanguage()
    const content = switchLanguage(data.termsAndCondition.contentJp, data.termsAndCondition.content)

    return (
        <Layout footer={false} hideCarousel>
            <Seo title='Terms and Conditions' />
            <ChangeHeaderInView threshold={0.1} color={COLOR_STATES.DARK_WHITE_BG}>
                <div className='bg-white pt200 pb200 m-pt120px m-pb100'>
                    <div className='p60 m-p20 max-800 ma'>
                        <ReactMarkdown remarkPlugins={[remarkGfm]} className='legal-content post--content text-grey'>
                            {content}
                        </ReactMarkdown>
                    </div>
                </div>
            </ChangeHeaderInView>
        </Layout>
    )
}

export const query = graphql`
    query TermsAndConditionsPage {
        pageData: datoCmsTermsAndCondition {
            content
        }
        termsAndCondition: datoCmsTermsAndCondition {
            content
            contentJp
        }
    }
`
